import React from 'react'
import Slider from './Slider'
import SiteMap from './SiteMap'
import Parallax from '../Parallax'
import BottomNavigation from '../BottomNavigation'
import { ROUTE_INTRODUCTION } from '../../constants'

function Home() {

  return (
    <div>
      <Slider/>
      <SiteMap/>
      <Parallax image="introduction" alt="Introduction"/>
      <BottomNavigation nextText="Présentation" nextLink={ ROUTE_INTRODUCTION } />
    </div>
  );
}

export default Home


/** WEBPACK FOOTER **
 ** ./src/components/Home/Home.jsx
 **/